var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 18,
    viewBox: "0 0 55 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_452_522",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2986 0.773438L0.710938 0.773438L0.710938 17.262H54.2986V0.773438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_452_522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_452_522",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2853 0.773438L0.710938 0.773438L0.710938 17.262H54.2853V0.773438Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_452_522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8494 10.1725C28.8494 11.9711 30.3484 13.5386 32.2227 13.5386C32.544 13.5386 32.7764 13.7697 32.7764 14.0195C32.7764 14.2506 32.544 14.4823 32.2227 14.4823C29.8671 14.4823 27.832 12.5234 27.832 10.1011V2.49662C27.832 2.17605 28.0637 2.01575 28.3849 2.01575C28.4478 2.01425 28.5104 2.0258 28.5685 2.04966C28.6268 2.07353 28.6794 2.10919 28.723 2.1544C28.7668 2.1996 28.8006 2.25336 28.8224 2.31227C28.8439 2.37118 28.8532 2.43396 28.8494 2.49662V5.6136H32.3835C32.7048 5.6136 32.8655 5.84469 32.8655 6.16527C32.867 6.22803 32.8555 6.29043 32.8315 6.34849C32.8074 6.40658 32.7719 6.45907 32.7265 6.50264C32.6812 6.5462 32.6274 6.57991 32.5683 6.60162C32.5092 6.62333 32.4463 6.63257 32.3835 6.62877H28.8494V10.1725Z",
    fill: "#FD9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9699 5.4707C39.1836 5.4707 40.3082 5.89813 41.1831 6.77105C42.0227 7.67937 42.5048 8.78337 42.5048 9.94079C42.5048 11.1453 42.025 12.3004 41.1714 13.1522C40.3177 14.0039 39.1598 14.4824 37.9526 14.4824C36.7451 14.4824 35.5875 14.0039 34.7336 13.1522C33.8799 12.3004 33.4004 11.1453 33.4004 9.94079C33.3996 7.5184 35.4347 5.4707 37.9699 5.4707ZM40.469 7.5184C39.8262 6.77037 38.9159 6.43176 37.9699 6.43176C35.9904 6.43243 34.4506 8.07074 34.4506 9.94079C34.4506 11.9003 35.9864 13.5206 37.9679 13.5206C39.9133 13.5206 41.538 11.9003 41.538 9.94079C41.54 9.06855 41.129 8.16023 40.469 7.5184Z",
    fill: "#FD9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8396 2.0332C54.072 2.0332 54.2863 2.24692 54.2863 2.51407V8.28385C54.2863 11.686 51.8944 14.4817 48.9308 14.4817C46.0033 14.4817 43.5933 11.686 43.5933 8.28385L43.5225 2.5675C43.5225 2.24692 43.7358 2.10467 44.0578 2.10467C44.2902 2.10467 44.5399 2.24692 44.5399 2.5675V8.28385C44.5399 11.1517 46.5394 13.5734 48.9313 13.5734C51.3595 13.5734 53.3047 11.1517 53.3047 8.28385V2.51407C53.3042 2.24692 53.5183 2.0332 53.8396 2.0332Z",
    fill: "#FD9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4082 14.4358C3.60932 13.1915 6.1766 12.5323 8.89116 12.5323C11.5689 12.5323 14.1362 13.1915 16.3735 14.4358C13.4761 9.53158 9.66102 3.01845 8.89116 1.4082C7.93723 3.01845 4.26937 9.53158 1.4082 14.4358ZM8.89116 11.9393C6.59165 11.9393 4.41599 12.4969 2.5516 13.5515C4.97563 9.39734 8.08314 3.87869 8.89116 2.51488C9.5432 3.87869 12.7739 9.39734 15.2301 13.5515C13.2896 12.4833 11.1074 11.9283 8.89116 11.9393Z",
    fill: "#FD9800",
    stroke: "#FD9800",
    strokeWidth: 0.67453,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8687 5.5436C25.8046 5.54023 25.7404 5.55037 25.6804 5.57336C25.6203 5.59631 25.5659 5.63164 25.5204 5.67696C25.475 5.7223 25.4396 5.77669 25.4166 5.83655C25.3935 5.89641 25.3834 5.96044 25.3867 6.02447L25.3158 10.0852C25.3031 10.9885 24.9346 11.8505 24.2899 12.4848C23.6451 13.1192 22.776 13.4748 21.8705 13.4748C20.965 13.4748 20.0959 13.1192 19.4511 12.4848C18.8064 11.8505 18.4379 10.9885 18.4253 10.0852V6.09594C18.4253 5.86418 18.193 5.61508 17.8716 5.61508C17.6219 5.61508 17.3896 5.86418 17.3896 6.09594V10.0852C17.3896 12.5603 19.3892 14.4838 21.8702 14.4838C24.3511 14.4838 26.3527 12.5603 26.3527 10.0852V6.02447C26.3472 5.89835 26.2944 5.77886 26.2047 5.68977C26.1151 5.60069 25.9952 5.54852 25.8687 5.5436Z",
    fill: "#FD9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55273 13.5503C4.41712 12.4957 6.59278 11.9381 8.89229 11.9381C11.1085 11.9271 13.2907 12.4821 15.2312 13.5503C12.7764 9.39613 9.54098 3.87747 8.89229 2.51367C8.0843 3.87747 4.97676 9.39613 2.55273 13.5503Z",
    stroke: "#FD9800",
    strokeWidth: 0.200363,
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.5252,
    height: 16.5078,
    fill: "white",
    transform: "translate(0.710938 0.773438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutou);
export default __webpack_public_path__ + "static/media/autou.2f3ead402b02abdf8b8ae087d61c2295.svg";
export { ForwardRef as ReactComponent };